import { useState } from 'react';
import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './simulator-footer.scss';
import { FiEdit } from 'react-icons/fi';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import Tooltip from '@mui/material/Tooltip';
import { AlertDialog, DialogResult } from '../../../../../components/analytics';
import {
  CreateNewScenarioDialog,
  TabNavigationLinks
} from '../../home/components';
import { Scenario } from '../../scenarios/types/scenario.model';
import { setScenario } from '../../home/store/simulator-home-slice';
import ScenarioCreateSuccessDialog from '../../home/components/scenario-create-success/scenario-create-success-dialog';
import { handleGlobalCheckboxValueInputChange } from '../../common/features/table/store/table-slice';
import { handleglobalheadercheckboxstate } from '../../common/features/table/store/table-slice';
interface ISimulatorFooterRequiredProps {
  nextClickHandler: () => void;
  isButtonSectionVisible: boolean;
}

interface ISimulatorFooterDefaultProps {
  isSimulationDisabled?: boolean;
  isResetSimulationDisabled?: boolean;
  isNextDisabled?: boolean;
  simulationClickHandler?: () => void;
  resetSimulationHandler?: () => void;
  isNextButtonHidden?: boolean;
}

interface ISimulatorFooterProps
  extends ISimulatorFooterRequiredProps,
  ISimulatorFooterDefaultProps {
  onBreadcrumbClick?: (routeURL: string) => boolean;
}

function SimulatorFooter({
  simulationClickHandler,
  isNextDisabled = false,
  isResetSimulationDisabled = false,
  resetSimulationHandler,
  isSimulationDisabled = false,
  nextClickHandler,
  isButtonSectionVisible,
  isNextButtonHidden = false,
  onBreadcrumbClick
}: ISimulatorFooterProps) {
  const simulationDetails = JSON.parse(
    localStorage.getItem('enableSimulation')
  );
  const appDispatch = useAppDispatch();
  const [isUpdateScenarioDialogOpen, setIsUpdateScenarioDialogOpen] =
    useState(false);
  const [isScenarioUpdatedSuccessfully, setScenarioUpdatedSuccessfully] =
    useState(false);

  const { currentScenario } = useAppSelector((state) => state.simulatorHome);
  const navigate = useNavigate();
  const onSimulateButtonClick = () => {
    navigate('/srm/simulation-summary');
  };
  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const tableState = useAppSelector(state => state.table.tableMetadaData);
  const globalCheckboxColumns = tableState.header?.filter(
    col => col.parent.field_format === "CHECKBOX" && col.parent.is_global_input_enable
  ) || [];



  const handleConfirmationDialogClose = (result: DialogResult) => {
    if (result === DialogResult.YES) {
      resetSimulationHandler();
      globalCheckboxColumns.forEach(column => {
        appDispatch(
          handleGlobalCheckboxValueInputChange({
            columnMetadata: column,
            newValue: 0,
          })
        );
        appDispatch(
          handleglobalheadercheckboxstate({
            columnMetadata: column,
            newValue: 0,
          })
        );
      });

    }
    setConfirmationDialogOpen(false);
  };

  const onEditClick = () => {
    setIsUpdateScenarioDialogOpen(true);
  };

  const updateScenarioClickHandler = (scenario: Scenario) => {
    setIsUpdateScenarioDialogOpen(false);
    if (scenario) {
      setScenarioUpdatedSuccessfully(true);
      appDispatch(setScenario(scenario));
    }
  };

  const handleUpdateSuccessDialogClose = () => {
    setScenarioUpdatedSuccessfully(false);
  };

  const onResetClick = () => {
    setConfirmationDialogOpen(true);
  };

  const getFooterLandingRoute = (scenario: Scenario) => {
    return `/srm/simulator/${scenario.pk_id}/planner-simulator`;
  }
  
  return (
    <>
      <Grid
        container
        sx={{
          position: 'sticky',
          bottom: 0,
          backgroundColor: (theme) => theme.palette.common.white,
          padding: '4px 8px',
          zIndex: 2
        }}
      >
        <Grid container alignItems='center' item xs={8}>
          {/* TODO: Remove this and integrate the common footer with support for adding buttons */}
          {currentScenario ? (
            <Grid
              item
              xs='auto'
              sx={{ px: 1 }}
              onClick={() => {
                navigate(getFooterLandingRoute(currentScenario));
              }}
            >
              <Grid
                container
                justifyContent='space-between'
                alignItems='center'
                sx={{
                  backgroundColor: '#FCF1E8',
                  p: 1,
                  color: '#ff6400',
                  maxWidth: '182px',
                  borderRadius: (theme) => theme.spacing(0.5),
                  cursor: 'pointer'
                }}
              >
                <Tooltip title={currentScenario.name} arrow>
                  <Typography
                    component='span'
                    className='footer-text'
                    sx={{
                      fontSize: '12px',
                      fontWeight: 700,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {currentScenario.name}
                  </Typography>
                </Tooltip>
                <FiEdit onClick={onEditClick} />
              </Grid>
            </Grid>
          ) : null}
          <Grid item xs='auto'>
            <TabNavigationLinks onBreadcrumbClick={onBreadcrumbClick} />
          </Grid>
        </Grid>
        {isButtonSectionVisible && (
          <Grid
            p={1}
            item
            xs={4}
            container
            spacing={1}
            justifyContent='end'
            alignItems='center'
          >
            <Button
              sx={{ ml: 1 }}
              variant='text'
              onClick={onResetClick}
              disabled={isResetSimulationDisabled}
            >
              Reset Simulator
              <InfoOutlinedIcon className='info-icon' />
            </Button>

            <Button
              disabled={isSimulationDisabled}
              onClick={simulationClickHandler}
              sx={{ ml: 1 }}
              variant='contained'
            >
              Simulate
            </Button>
            {!isNextButtonHidden && (
              <Button
                variant='contained'
                sx={{ ml: 1 }}
                onClick={nextClickHandler}
                disabled={
                  (simulationDetails
                    ? !simulationDetails.enableSimulation
                    : false) || isNextDisabled
                }
              >
                Next
              </Button>
            )}
          </Grid>
        )}
      </Grid>
      {isUpdateScenarioDialogOpen && (
        <CreateNewScenarioDialog
          isEditable
          currentScenario={currentScenario}
          isDuplicate={false}
          isOpen={isUpdateScenarioDialogOpen}
          onClose={updateScenarioClickHandler}
        />
      )}
      {isScenarioUpdatedSuccessfully ? (
        <ScenarioCreateSuccessDialog
          imagePath='/static/images/success.svg'
          isOpen={isScenarioUpdatedSuccessfully}
          onClose={handleUpdateSuccessDialogClose}
          message='Scenario Updated Successfully'
        />
      ) : null}
      <AlertDialog
        closeHandler={handleConfirmationDialogClose}
        isDialogOpen={isConfirmationDialogOpen}
        message='Filters will reset and all changes to simulation will be lost. Continue?'
        title='Reset'
      />
    </>
  );
}

SimulatorFooter.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  simulationClickHandler: () => { },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  resetSimulationHandler: () => { },
  isResetSimulationDisabled: false,
  isNextDisabled: false,
  isSimulationDisabled: false,
  isNextButtonHidden: false
};

export default SimulatorFooter;
